import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Equip.module.css';
import { DBCheckBox, DBIntField, DBTextField, DBTextArea } from '_components';


class PatientCareCenterNoteSubjectiveEquip extends React.Component {

    handleOxygenClick(selected) {
        if (!selected) {
            this.props.clearField(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, 'EVSUBEQOXYGENTXT');
        }
    }

    handleAssistDevClick(selected) {
        if (!selected) {
            this.props.clearField(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, 'EVSUBEQASSISTDEVTXT');
        }
    }

    handleOrthosisClick(selected) {
        if (!selected) {
            this.props.clearField(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, 'EVSUBEQORTHOSISTXT');
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='subj_equip' name='Equipment' level={1}>

                <div className={styles.row}>
                    <label className={styles.col1}>Patient presents with:</label>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBEQIV'
                        className={styles.col2}
                        label='IV'
                    />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBEQCATHETER'
                        className={styles.col3}
                        label='Catheter'
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <span className={styles.col2}>
                        {!this.props.oxygen &&
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                field='EVSUBEQOXYGEN'
                                label='Oxygen'
                                onClick={(selected) => this.handleOxygenClick(selected)}
                            />
                        }
                        {this.props.oxygen &&
                            <span>
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBEQOXYGEN'
                                    label='Oxygen device at'
                                    onClick={(selected) => this.handleOxygenClick(selected)}
                                />
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBEQOXYGENTXT'
                                    min={0}
                                    max={100}
                                    className={styles.oxygen}
                                />
                                <label className={styles.oxygen_label}>%</label>
                            </span>
                        }
                    </span>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBEQTELEMETRY'
                        className={styles.col3}
                        label='Telemetry'
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBEQPNEUMATIC'
                        className={styles.col2}
                        label='Pneumatic pump'
                    />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBEQCOMPRESS'
                        className={styles.col3}
                        label='Compression Garmet'
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <span className={styles.col2}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBEQASSISTDEV'
                            label='Assistive Device(s)'
                            className={styles.checkbox}
                            onClick={(selected) => this.handleAssistDevClick(selected)}
                        />
                        {this.props.assistDev &&
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                field='EVSUBEQASSISTDEVTXT'
                                className={styles.textfield}
                            />
                        }
                    </span>
                    <span className={styles.col3}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBEQORTHOSIS'
                            label='Orthosis'
                            onClick={(selected) => this.handleOrthosisClick(selected)}
                        />
                        {this.props.orthosis &&
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                field='EVSUBEQORTHOSISTXT'
                                className={styles.textfield}
                            />
                        }
                    </span>
                </div>
                <div className={styles.row}>
                    <div className={styles.col1_top}>Other:</div>
                    <DBTextArea
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBEQOTHER'
                        className={styles.textarea}
                    />
                </div>

            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    return {
        noteId: noteId,
        evno: evno,
        oxygen: state.entities.notes.PTEVAL[evno].EVSUBEQOXYGEN ? state.entities.notes.PTEVAL[evno].EVSUBEQOXYGEN : false,
        assistDev: state.entities.notes.PTEVAL[evno].EVSUBEQASSISTDEV ? state.entities.notes.PTEVAL[evno].EVSUBEQASSISTDEV : false,
        orthosis: state.entities.notes.PTEVAL[evno].EVSUBEQORTHOSIS ? state.entities.notes.PTEVAL[evno].EVSUBEQORTHOSIS : false
    };
}

const connectedPatientCareCenterNoteSubjectiveEquip = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveEquip);
export { connectedPatientCareCenterNoteSubjectiveEquip as PatientCareCenterNoteSubjectiveEquip };

